module.exports = __webpack_public_path__ + "static/media/mobile.dc2a3253.jpg";